export default {
  items: [
    {
      name: 'Dashboard',
      url: '/dashboard',
      icon: 'icon-speedometer'
    },
    {
      name: 'User Manager',
      url: '/users',
      icon: 'fa fa-users'
    },
    /*{
      name: 'All Redeem Codes',
      url: '/all_redeem_codes',
      icon: 'fa fa-gift'
    },
    {
      name: 'Earn Redeem Codes',
      url: '/earn_redeem_codes',
      icon: 'fa fa-gift'
    },*/
    {
      name: 'Redeem Codes With Value',
      url: '/redeem_codes_with_value',
      icon: 'fa fa-gift'
    },
    {
      name: 'Quiz Earn Redeem Codes',
      url: '/quiz_earn_redeem_codes',
      icon: 'fa fa-file-text'
    },
    {
      name: 'Admin Bills',
      url: '/admin_bills',
      icon: 'fa fa-money'
    },
    {
      name: 'Coins',
      url: '/coins',
      icon: 'fa fa-btc'
    },
    {
      name: 'Refer',
      url: '/refer',
      icon: 'fa fa-user-plus'
    },
    /*{
      name: 'Service Manager',
      url: '/services',
      icon: 'fa fa-wrench'
    },
    {
      name: 'Car Manager',
      url: '/car',
      icon: 'fa fa-car',
      children: [
        {
          name: 'Category Manager',
          url: '/car/categories',
          icon: 'fa fa-list'
        },
        {
          name: 'Car Brand',
          url: '/car/brands',
          icon: 'fa fa-list'
        },
        {
          name: 'Car Model',
          url: '/car/models',
          icon: 'fa fa-medium'
        },
        {
          name: 'Cars Listing',
          url: '/cars',
          icon: 'fa fa-car'
        },
      ]
    },*/
    /*{
      name: 'Products Manager',
      url: '/items',
      icon: 'fa fa-cutlery',
      children: [
        {
          name: 'Category Manager',
          url: '/items/categories',
          icon: 'fa fa-list'
        },
        {
          name: 'Sub Category',
          url: '/items/sub-categories',
          icon: 'fa fa-list-alt'
        },
        {
          name: 'Products',
          url: '/items/products',
          icon: 'fa fa-list'
        },
      ]
    },*/
    /*{
      name: 'Dealer Shelf Manager',
      url: '/dealer/shelf',
      icon: 'fa fa-table'
    },*/
    /*{
      name: 'Orders',
      url: '/orders',
      icon: 'fa fa-shopping-cart',
      children: [
        {
          name: 'Current Order',
          url: '/orders/list',
          icon: 'fa fa-plus',
        },
        {
          name: 'Order History',
          url: '/orders/history',
          icon: 'fa fa-plus',
        }
      ]
    },
    {
      name: 'Manage Coupon',
      url: '/discount-code',
      icon: 'fa fa-cc'
    },*/
    /*{
      name: 'Post Manager',
      url: '/posts',
      icon: 'fa fa-sticky-note-o'
    },
    {
      name: 'Notifications Manager',
      url: '/notifications',
      icon: 'fa fa-bell'
    },
    {
      name: 'Advertisement Manager',
      url: '/advertisements',
      icon: 'fa fa-picture-o'
    },
    {
      name: 'Banners Manager',
      url: '/banners',
      icon: 'fa fa-picture-o'
    },
    {
      name: 'Email Templates',
      url: '/email-templates',
      icon: 'fa fa-envelope'
    },
    {
      name: 'Content Manager',
      url: '/contents',
      icon: 'fa fa-file-text'
    },*/
    {
      name: 'Notifications Manager',
      url: '/notifications',
      icon: 'fa fa-bell'
    },
    {
      name: 'InApp Notifications',
      url: '/in-app-notification',
      icon: 'fa fa-mobile-phone'
    },
    {
      name: 'Quiz & Games Manager',
      url: '/game_coins',
      icon: 'fa fa-gamepad'
    },
    {
      name: 'Quiz & Games Settings',
      url: '/game_score',
      icon: 'fa fa-gamepad'
    },
    {
      name: 'Leaderboard Prizes',
      url: '/leaderboard/prizes',
      icon: 'fa fa-trophy'
    },
    {
      name: 'Leaderboard Settings',
      url: '/leaderboard/settings',
      icon: 'fa fa-cog'
    },
    {
      name: 'Game Leaderboard Prizes',
      url: '/leaderboard/game-prizes',
      icon: 'fa fa-trophy'
    },
    {
      name: 'Game Leaderboard Settings',
      url: '/leaderboard/game-settings',
      icon: 'fa fa-cog'
    },
    {
      name: 'Settings',
      url: '/settings',
      icon: 'fa fa-cogs'
    },

  ],
};
